document.addEventListener('DOMContentLoaded', function () {
  const colorText         = document.getElementById('ps-selected-color');
  const variationBlocks   = document.querySelectorAll('.ps-variation-block');
  const variantSelect     = document.querySelector("form#add-to-cart input[name='id']");
  const misteryGift       = document.querySelector("form#add-to-cart input[name='mistery_gift']");
  const discountCodeInput = document.querySelector("form#add-to-cart input[name='discount_code']");
  const submitButton      = document.querySelector("form#add-to-cart button");

  // — Utility to read the Shopify discount cookie —
  function getDiscountCookie() {
    const match = document.cookie.match(/(?:^|;\s*)discount=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  // If we already have a discount cookie, keep it in the hidden field
  const persistedCode = getDiscountCookie();
  if (persistedCode && discountCodeInput) {
    discountCodeInput.value = persistedCode;
  }

  // Rewrite any native checkout links/forms to include the code
  document.querySelectorAll('a[href^="/checkout"]').forEach(link => {
    if (persistedCode) {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('discount', persistedCode);
      link.href = url.pathname + url.search;
    }
  });
  document.querySelectorAll('form[action^="/checkout"]').forEach(form => {
    form.addEventListener('submit', function(event) {
      if (persistedCode) {
        event.preventDefault();
        window.location.href = `/checkout?discount=${encodeURIComponent(persistedCode)}`;
      }
    });
  });

  // — Variation picker logic —
  variationBlocks.forEach(block => {
    block.addEventListener('click', function () {
      colorText.textContent = this.dataset.color;
      variationBlocks.forEach(b => b.classList.remove('selected'));
      this.classList.add('selected');
      variantSelect.value = this.dataset.variantId;
      const thumb = document.querySelector(
        `.thumbnails-wrapper img[data-position='${this.dataset.featuredImagePosition}']`
      );
      if (thumb) thumb.click();
    });
  });
  if (variationBlocks.length) variationBlocks[0].click();

  // — Add-to-cart + remove old items (preserving discount) + redirect —
  submitButton.addEventListener('click', async function (event) {
    event.preventDefault();
    submitButton.disabled = true;
    submitButton.classList.add('add-to-cart-btn-spining');

    try {
      // 1) Fetch current cart state
      const cart = await fetch('/cart.js').then(res => res.json());

      // 2) Build an updates map to zero out every existing line item by variant_id
      const updates = {};
      cart.items.forEach(item => {
        updates[item.id] = 0;
      });

      // 3) Remove all old items, preserving any active discount
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      // 4) Add only Pro+ and Mystery Gift
      const items = [{ id: variantSelect.value, quantity: 1 }];
      if (misteryGift.value) {
        items.push({ id: misteryGift.value, quantity: 1 });
      }
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!addRes.ok) {
        console.error('Add-to-cart failed:', addRes.statusText);
        return;
      }

      // 5) Redirect via discount endpoint so the code sticks in session
      const code = discountCodeInput.value.trim();
      if (code) {
        window.location.href =
          `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/checkout')}`;
      } else {
        window.location.href = '/checkout';
      }

    } catch (err) {
      console.error('Cart process error:', err);
    } finally {
      submitButton.disabled = false;
      submitButton.classList.remove('add-to-cart-btn-spining');
    }
  });
});
